
import React, { } from "react";
import { CrumbToggleScenario } from "./CrumbToggles";
import ToggleSet from "./ToggleSet";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HelpIcon from "../Dialogs/Help/HelpIcon";
import CloseIcon from "./CloseIcon";
import { iconSize } from "../App/GridRenderers";
import { GridCsv } from "./GridCsv";
import { InputCheck, InputSwitch } from "./Inputs/Input_Check";
import FunctionsRoundedIcon from '@mui/icons-material/FunctionsRounded';
export const GridHeader = ({ name, clientJson,
    clients, client,
    onClientChange = null,
    dataSets, dataSet,
    onDataSetChange = null,
    onExpand = null,
    onClose = null,
    gridRefFn,
    scenName = null,
    showSums = false,
    onShowSums = null,

}) => {
    return (
        <Stack direction="row" spacing={4}>
            {onClientChange !== null && (
                <CrumbToggleScenario
                    set={clients}
                    current={client}
                    onChange={onClientChange}
                    clientJson={clientJson}
                    scen_name={scenName}
                />
            )}
            {(onDataSetChange !== null &&
                <ToggleSet
                    set={dataSets}
                    current={dataSet}
                    onChange={onDataSetChange}
                />
            )}
            <InputSwitch
                value={showSums}
                label="Aggregate"
                disabled={onShowSums === null}
                onChange={onShowSums}
            />
            <Typography
                id="s-die-Income-calc"
                variant="h6"
                gutterBottom
                sx={{ pt: 1, pl: 3 }}
            >
                {name}
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    flexGrow: 1,
                    alignContent: "center",
                    justifyContent: "flex-end",
                }}
            >
                <Stack direction="row" spacing={4} >
                    <GridCsv
                        filename={"MyOwnFP " + scenName + " " + client + " " + dataSet + " " + name}
                        name={name}
                        scenario={scenName}
                        client={client}
                        dataset={dataSet}
                        gridRefFn={gridRefFn}
                    />
                    <HelpIcon mt={-1} />
                    {onExpand !== null && (
                        <Stack>
                            <Box sx={{ mt: 1, mr: 1 }}>
                                <Tooltip title="Expand the window"
                                    enterDelay={1000}>

                                    <FontAwesomeIcon
                                        size={iconSize}
                                        color="lightgray"
                                        icon={faExpand}
                                        onClick={onExpand}
                                    />
                                </Tooltip>
                            </Box>
                        </Stack>
                    )}
                    {onClose !== null && (
                        <CloseIcon mt={-.5}
                            onClick={onClose}
                        />
                    )}
                </Stack>
            </Box>
        </Stack>
    )
}

